<div class="coverage-cell">
  <span class="fa fa-circle status-indicator" [class]="statusClassName"> </span>
  <div class="coverage-text" [attr.aria-label]="formattedText" [title]="formattedText">
    {{ formattedText }}
  </div>
</div>
